import { Icon20ExclamationMarkOutline } from '@vkontakte/icons';
import React from 'react';
import { useSelector } from 'react-redux';
import { UserQuotaSelectors } from 'reactApp/modules/userQuota/userQuota.selectors';

import styles from './OverquotaInfoBlock.css';

interface OverquotaInfoBlockProps {
    showWarningIcon?: boolean;
}

export function OverquotaInfoBlock({ showWarningIcon }: OverquotaInfoBlockProps) {
    const { used, userTotalSpace } = useSelector(UserQuotaSelectors.getUserQuotaState);
    const overquota = useSelector(UserQuotaSelectors.getOverQuota);
    return (
        <div className={styles.quota}>
            {showWarningIcon && (
                <div className={styles.quotaIcon}>
                    <Icon20ExclamationMarkOutline width={26} height={26} />
                </div>
            )}
            <div className={styles.quotaTitle}>
                Занято {used?.value} из {userTotalSpace?.value}
            </div>
            <div className={styles.quotaSeparator} />
            <div className={styles.quotaText}>Облако переполнено на {overquota?.value}</div>
        </div>
    );
}
